module.exports = __webpack_public_path__ + "img/close.d6505300.svg";